// File-type icon badge. The PDF/PNG/JPG rgba() literals are the file-kind tone
// palette (semantic per-type accents), not arbitrary hardcoded colors.

export function FileIcon({ kind, compact = false }: { kind: string | null; compact?: boolean }) {
  const upper = (kind ?? 'FILE').toUpperCase()
  const palette: Record<string, { bg: string; color: string; border: string }> = {
    PDF: { bg: 'rgba(242, 92, 92, 0.16)', color: '#f25c5c', border: 'rgba(242, 92, 92, 0.45)' },
    PNG: { bg: 'rgba(179, 156, 255, 0.18)', color: '#b39cff', border: 'rgba(179, 156, 255, 0.45)' },
    JPG: { bg: 'rgba(179, 156, 255, 0.18)', color: '#b39cff', border: 'rgba(179, 156, 255, 0.45)' },
    JPEG: {
      bg: 'rgba(179, 156, 255, 0.18)',
      color: '#b39cff',
      border: 'rgba(179, 156, 255, 0.45)',
    },
    TXT: {
      bg: 'var(--card)',
      color: 'var(--foreground)',
      border: 'var(--border)',
    },
  }
  const tone = palette[upper] ?? palette.TXT
  return (
    <div
      style={{
        width: compact ? 28 : 36,
        height: compact ? 36 : 44,
        flexShrink: 0,
        borderRadius: '8px',
        background: tone.bg,
        border: `1px solid ${tone.border}`,
        color: tone.color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'var(--font-mono)',
        fontSize: compact ? 8 : 9,
        fontWeight: 700,
        letterSpacing: 0.4,
      }}
    >
      {upper}
    </div>
  )
}
